// import * as React from "react";

// // @ts-ignore
// import { cn } from "Assessment/src/lib/utils";

// // Fallback cn function if import fails
// const cnFallback = (...classes: any[]) => classes.filter(Boolean).join(' ');

// const Card = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(({ className, ...props }, ref) => (
//   <div 
//     ref={ref} 
//     data-slot="card"
//     className={cn(
//       "rounded-lg border bg-card text-card-foreground shadow-sm",
//       className
//     ) || cnFallback(
//       "rounded-lg border bg-card text-card-foreground shadow-sm",
//       className
//     )} 
//     {...props} 
//   />
// ));
// Card.displayName = "Card";

// const CardHeader = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
//   ({ className, ...props }, ref) => (
//     <div ref={ref} className={cn("flex flex-col space-y-1.5 p-6", className)} {...props} />
//   ),
// );
// CardHeader.displayName = "CardHeader";

// const CardTitle = React.forwardRef<HTMLParagraphElement, React.HTMLAttributes<HTMLHeadingElement>>(
//   ({ className, ...props }, ref) => (
//     <h3 ref={ref} className={cn("text-2xl font-semibold leading-none tracking-tight", className)} {...props} />
//   ),
// );
// CardTitle.displayName = "CardTitle";

// const CardDescription = React.forwardRef<HTMLParagraphElement, React.HTMLAttributes<HTMLParagraphElement>>(
//   ({ className, ...props }, ref) => (
//     <p ref={ref} className={cn("text-sm text-muted-foreground", className)} {...props} />
//   ),
// );
// CardDescription.displayName = "CardDescription";

// const CardContent = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
//   ({ className, ...props }, ref) => <div ref={ref} className={cn("p-6 pt-0", className)} {...props} />,
// );
// CardContent.displayName = "CardContent";

// const CardFooter = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
//   ({ className, ...props }, ref) => (
//     <div ref={ref} className={cn("flex items-center p-6 pt-0", className)} {...props} />
//   ),
// );
// CardFooter.displayName = "CardFooter";

// export { Card, CardHeader, CardFooter, CardTitle, CardDescription, CardContent };


import * as React from "react";

// @ts-ignore
import { cn } from "Assessment/src/lib/utils";
import { useColor } from "components/ui/ColorContext";
// Fallback cn function if import fails
const cnFallback = (...classes: any[]) => classes.filter(Boolean).join(' ');
//  const { primaryColor } = useColor();
// const Card = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(({ className, ...props }, ref) => (
//   <div 
//     ref={ref} 
//     data-slot="card"
//     className={cn(
//       "rounded-lg border bg-card text-card-foreground shadow-sm",
//       className
//     ) || cnFallback(
//       "rounded-lg border bg-card text-card-foreground shadow-sm",
//       className
//     )} 
//     {...props} 
//   />
// ));


const Card = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => (
  <div
    ref={ref}
    data-slot="card"
    className={cn(
      `
      relative
      rounded-xl
      border
      shadow-lg
      text-card-foreground
      `,
      className
    )}
    style={{
      backgroundColor:
        "color-mix(in srgb, var(--theme-color) 10%, white)",
      borderColor:
        "color-mix(in srgb, var(--theme-color) 22%, transparent)",
      boxShadow: `
        0 10px 30px rgba(0,0,0,0.25),
        inset 0 1px 0 rgba(255,255,255,0.35)
      `
    }}
    {...props}
  />
));



Card.displayName = "Card";





const CardHeader = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
  ({ className, ...props }, ref) => (
    <div ref={ref} className={cn("flex flex-col space-y-1.5 p-6", className)} {...props} />
  ),
);
CardHeader.displayName = "CardHeader";

// const CardTitle = React.forwardRef<HTMLParagraphElement, React.HTMLAttributes<HTMLHeadingElement>>(
//   ({ className, ...props }, ref) => (
//     <h3 ref={ref} className={cn("text-2xl font-semibold leading-none tracking-tight", className)} {...props} />
//   ),
// );
// const CardTitle = React.forwardRef<HTMLParagraphElement, React.HTMLAttributes<HTMLHeadingElement>>(
//   ({ className, ...props }, ref) => (
//     <h3 ref={ref} className={cn("text-2xl font-semibold leading-none tracking-tight text-white/90", className)} {...props} />
//   ),
// );
// CardTitle.displayName = "CardTitle";
// CardTitle component that uses primary color
const CardTitle = React.forwardRef<HTMLParagraphElement, React.HTMLAttributes<HTMLHeadingElement>>(
  ({ className, ...props }, ref) => {
    // Call the hook INSIDE this component function
    const { primaryColor } = useColor();
    
    return (
      <h3 
        ref={ref} 
        className={cn(
          "text-2xl font-semibold leading-none tracking-tight", 
          className
        )}
        style={{
          color: primaryColor || "rgba(255, 255, 255, 0.9)"
        }}
        {...props} 
      />
    );
  },
);
CardTitle.displayName = "CardTitle";
// const CardDescription = React.forwardRef<HTMLParagraphElement, React.HTMLAttributes<HTMLParagraphElement>>(
//   ({ className, ...props }, ref) => (
//     <p ref={ref} className={cn("text-sm text-muted-foreground", className)} {...props} />
//   ),
// );
const CardDescription = React.forwardRef<HTMLParagraphElement, React.HTMLAttributes<HTMLParagraphElement>>(
  ({ className, ...props }, ref) => (
    <p ref={ref} className={cn("text-sm text-white/70", className)} {...props} />
  ),
);
CardDescription.displayName = "CardDescription";

// const CardContent = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
//   ({ className, ...props }, ref) => <div ref={ref} className={cn("p-6 pt-0", className)} {...props} />,
// );
const CardContent = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
  ({ className, ...props }, ref) => <div ref={ref} className={cn("p-6 pt-0 text-white/100", className)} {...props} />,
);
CardContent.displayName = "CardContent";

const CardFooter = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
  ({ className, ...props }, ref) => (
    <div ref={ref} className={cn("flex items-center p-6 pt-0", className)} {...props} />
  ),
);
CardFooter.displayName = "CardFooter";

export { Card, CardHeader, CardFooter, CardTitle, CardDescription, CardContent };
